import { ArrowUpRight, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { SERVICES } from "../../lib/constants";
import { ServiceIcon, BRAND_COLORS, BRAND_GLOW } from "./ServiceIcon";

export const ServicesGrid = ({ detailed = false }) => {
  return (
    <div
      data-testid="services-grid"
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5"
    >
      {SERVICES.map((service, idx) => {
        const brand = BRAND_COLORS[service.iconKey];
        const glow = BRAND_GLOW[service.iconKey];
        return (
          <article
            key={service.id}
            data-testid={`service-card-${service.id}`}
            className="rm-card rm-service-card p-8 flex flex-col group"
            style={{
              "--brand": brand,
              "--brand-glow": glow,
            }}
          >
            <div className="flex items-start justify-between mb-6">
              <div
                className="h-12 w-12 flex items-center justify-center border border-zinc-800 bg-zinc-900/60 transition-all duration-300 rm-service-icon-tile"
                style={{ color: brand }}
              >
                <ServiceIcon iconKey={service.iconKey} colored />
              </div>
              <span className="font-mono text-xs text-zinc-500">
                0{idx + 1}
              </span>
            </div>
            <div
              className="rm-overline mb-2"
              style={{ color: brand }}
            >
              {service.platform}
            </div>
            <h3 className="font-display text-2xl font-bold tracking-tight mb-3 text-white">
              {service.title}
            </h3>
            <p className="text-sm text-zinc-400 leading-relaxed mb-6">
              {service.description}
            </p>

            {detailed && (
              <ul className="space-y-2 mb-6">
                {service.highlights.map((h) => (
                  <li
                    key={h}
                    className="flex items-start gap-2 text-sm text-zinc-300"
                  >
                    <Check
                      className="h-4 w-4 mt-0.5 flex-shrink-0"
                      style={{ color: brand }}
                    />
                    <span>{h}</span>
                  </li>
                ))}
              </ul>
            )}

            <div className="mt-auto pt-2">
              <Link
                to="/contact"
                data-testid={`service-cta-${service.id}`}
                className="inline-flex items-center gap-2 text-sm font-medium text-zinc-300 rm-service-cta transition-colors"
              >
                Start a conversation
                <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </div>
          </article>
        );
      })}
    </div>
  );
};
